import "./styles.css";

// document.getElementById("app").innerHTML = `
// <button class="btn">Hello world</button>
// `;
